export default {"src":"/_next/static/media/russia.fd643a61.svg","height":39,"width":55};